module.exports = __webpack_public_path__ + "static/media/logo.76a5ad17.png";